import { isAxiosError } from 'axios';

/**
 * A checkout endpoint answers with 404 once its cart is gone, which happens the moment a
 * booking is created. The body is not inspected: the api uses a plain 404 on most endpoints
 * and a validation-shaped one on booking, and a checkout call has no other reason to 404.
 */
export function isCartNotFoundError(error: unknown): boolean {
	return isAxiosError(error) && error.response?.status === 404;
}

/**
 * The api answers 422 when a step does not validate. Anything else, from a dropped
 * connection to a 500, says nothing about the reservation itself.
 */
export function isValidationError(error: unknown): boolean {
	return isAxiosError(error) && error.response?.status === 422;
}
